<template>
  <el-dialog
    title="Filters"
    :visible="filter_dialog"
    width="500px"
    top="3vh"
    :modal="true"
    @close="setFilterDialog(false)"
  >
    <el-input
      type="text"
      v-model="filters.name"
      clearable
      placeholder="Artist/Label Name"
    />
    <div slot="footer">
      <el-button type="primary" size="mini" @click="filterData">
        Filter
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('vcLabel', ['filter_dialog', 'filters'])
  },
  methods: {
    ...mapMutations('vcLabel', ['setFilterDialog', 'setLoading', 'setPage']),
    ...mapActions('vcLabel', ['readLabels']),

    async filterData() {
      this.setPage(1)
      const labels = await this.readLabels()
      if (labels) this.setFilterDialog(false)
    }
  }
}
</script>
